import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ctaBanner from "../assests/about/cta-banner.jpg";

const CTA = () => {
  return (
    <section
      className="relative bg-cover bg-center py-20 lg:py-28"
      style={{
        backgroundImage: `url(${ctaBanner})`,
      }}
    >
      {/* Black Overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 text-center text-white">
        <h2 className="text-3xl lg:text-4xl font-bold">
          Ready to Start Your Project?
        </h2>

        <p className="mt-4 text-gray-200 text-lg max-w-2xl mx-auto">
          Get in touch today to discuss your project and arrange a consultation.
        </p>

        <Link
          to="/contact"
          className="inline-flex items-center gap-2 mt-8 px-8 py-4 bg-[#F57C00] text-white font-semibold rounded-lg hover:bg-[#e36f00] transition"
        >
          Get a Quote
          <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  );
};

export default CTA;
